export interface IInvoiceCreditPaymentsReport {
    id: string,
    centerId: number,
    centerAlias: string,
    organType: number,
    invoiceNumber: number,
    invoiceYear: number,
    invoiceMonth: number,
    transplantCount: number,
    invoiceAmount: number,
    amountPaid: number,
    amountRemaining: number,
    paymentDate: string,
    paymentType: string,
    paymentAmount: number,
    sentDateTime: string
    daysDelinquent: number
}
